import { mapActions, mapGetters } from 'vuex'

import { cloneDeep } from 'lodash'

import { SENDINGS_OUTGOING_FILTER, downloadable, fillDependence, generateServices, permissionPresets, services } from '@/utils'

import render from './render'

export default {
  name: 'Details',

  mixins: [
    generateServices({
      name: services.sendings,

      async inputFilter(result) {
        if (result && result.payload && (result.payload.file || result.payload.image || result.payload.audio)) {
          const [ id1, id2 ] = (result.payload.file || result.payload.image || result.payload.audio).split('/')

          result.payload.fileId = id2 || id1

          await fillDependence.call(this, result, {
            service: services.storage,
            permissions: permissionPresets.meUp,
            pathToId: 'payload.fileId',
            pathToObject: 'File',
            outputPath: 'File',
            requestParams: {
              query: {
                return: 'meta'
              }
            }
          })
        }

        return result
      },

      find: {
        bucketEnabled: true,
        defaultFilter: cloneDeep(SENDINGS_OUTGOING_FILTER),
        disableWatcherFilter: true
      },
      get: false,
      update: false,
      create: false,
      remove: false
    }),

    downloadable({ permissionAccept: `advanced.${services.sendings}.find` })
  ],

  props: {
    filter: {
      type: Object,
      default: () => cloneDeep(SENDINGS_OUTGOING_FILTER),
      required: true
    }
  },

  computed: {
    ...mapGetters({ findSendingFromRouteParams: 'global/findSendingFromRouteParams' })
  },

  watch: {
    filter: {
      handler() {
        this.restData[services.sendings].find.filter = cloneDeep(this.filter)
        if (this.restData[services.sendings].find.pagination.offset !== 0) {
          this.restData[services.sendings].find.pagination.offset = 0
        }
      },
      deep: true
    },
    $route: {
      handler() {
        this.getFilterFromRouter()
      },
      deep: true
    },

    findSendingFromRouteParams() {
      this.getFilterFromRouter()
    }
  },

  mounted() {
    this.getFilterFromRouter()
  },

  methods: {
    ...mapActions({ setFindSendingFromRouteParams: 'global/setFindSendingFromRouteParams' }),

    async getFilterFromRouter() {
      const id = this.$route?.query?.id || this.$route?.params?.id
      const providerId = this.$route?.query?.providerId || this.$route?.params?.providerId
      const ownerId = this.$route?.query?.ownerId || this.$route?.params?.ownerId
      const groupId = this.$route?.query?.groupId || this.$route?.params?.groupId
      const createdAt = this.$route?.query?.createdAt || this.$route?.params?.createdAt
      if (id) {
        this.restData[services.sendings].find.filter.id = id
      }
      if (providerId) {
        this.restData[services.sendings].find.filter.meta._routing.provider = providerId
      }
      if (ownerId) {
        this.restData[services.sendings].find.filter.OwnerId = ownerId
      }
      if (groupId) {
        this.restData[services.sendings].find.filter.groupId = groupId
      }
      if (createdAt) {
        this.restData[services.sendings].find.filter.createdAt = JSON.parse(createdAt)
      }
      if (id || providerId || ownerId || groupId || createdAt) {
        this.$emit('filter', this.restData[services.sendings].find.filter)
        await this.rest[services.sendings].find()
        this.setFindSendingFromRouteParams(false)
      }
    }
  },

  render
}
